import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Client as TwilioChat } from 'twilio-chat'
import { url } from '../utils/config';
import { btnRound } from '../utils/style';
import arrowBlack from '../assets/icons/arrow_black.png'

const Chat = ({ selectedChannel, setShowChatScreen, id, userId }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [chatClient, setChatClient] = useState(null);
  const [ notified, setNotified ] = useState(false)
  

  useEffect(() => {
    initializeChat();
    console.log(notified)
  }, []);

  const initializeChat = async () => {
    try {
        const response = await axios.post(url + '/chat_token', { identity: 'technician_' + id});
        const chatClient = new TwilioChat(response.data.token)
        setChatClient(chatClient);
        const channel = await chatClient.getChannelBySid(selectedChannel.sid);
        console.log(channel)
        const messages = await channel.getMessages();
        console.log(messages)
        setMessages(messages.items);
        
        channel.on('messageAdded', (message) => {
        setMessages((prev) => [...prev, message]);
        });
    } catch (error) {
        console.log(error)
        if(error.status === 403) {
          const join = await axios.post(url + '/join_channel', { identity: 'technician_' + id, channelSid: selectedChannel.sid});
          initializeChat()
        }
    }
  };

  const handleSendMessage = async () => {
    if (chatClient) {
      try {
        const channel = await chatClient.getChannelBySid(selectedChannel.sid);
        await channel.sendMessage(newMessage);
        if(!notified) {
          const token = window.localStorage.getItem('token');
          const headers = { authorization: `bearer ${token}` };
          await axios.post(url + '/chat_notification', {userId, body: newMessage}, { headers })
          setNotified(true)
        }
        setNewMessage('');
      } catch (error) {
        console.log(error)
      }
    }
  };

  return (
    <div className='w-screen fixed top-0 left-0 right-0 bottom-0 pb-12 pt-14 bg-white'>
        <div className="flex flex-col h-[100%] px-4">
            <div className='flex gap-4 items-center'>
              <button className={btnRound} onClick={() => setShowChatScreen(false)}>
                      <img src={arrowBlack}  height={20} width={20}/>
              </button>
              <h2 className="text-xl font-bold">Chat with {selectedChannel.friendlyName}</h2>
            </div>
            <div className="flex-1 overflow-y-auto bg-gray-50 p-4 rounded shadow">
                {messages.map((message, index) => (
                <div key={index} className="mb-2">
                    <strong className="text-blue-500">{message.author}:</strong> {message.body}
                </div>
                ))}
            </div>
            <div className="mt-4 flex">
                <input
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Type a message"
                className="flex-1 p-2 border rounded-l-lg border-gray-300 focus:outline-none"
                />
                <button
                onClick={handleSendMessage}
                className="bg-blue-500 text-white p-2 rounded-r-lg hover:bg-blue-600"
                >
                Send
                </button>
            </div>
        </div>
    </div>
  );
};

export default Chat;
